import styled from "@emotion/styled";
export const StyledProductFeaturesTableSection = styled.div`
  text-align: left;
  display: flex;
  justify-content: flex-start;
  padding: 12px 0px;
  border-bottom: 1px solid rgb(230, 233, 239);
  grid-column: 1/-1;
  h3 {
    margin: 0;
    font-weight: 700;
    letter-spacing: 0.361538px;
    font-size: 16px;
  }
`;
